function Header({title}) {
  const image="./bannerfile.png";
  return (
    <header className="header">
        <div className='imgbanner'>             
        <h1>PRAGJYOTISHPUR UNIVERSITY
        </h1>
        </div>
  </header>
  )
}

export default Header